(function (angular, app) {
    "use strict";

    angular.module(app.modules.scoring.name)
       .factory(app.modules.scoring.services.score, ScoreFactory);

    ScoreFactory.$inject = [app.modules.common.services.http
        , app.modules.common.constants.appsettings
        , app.modules.common.services.functions
    ];

    function ScoreFactory($http
        , ggSettings
        , ggFunctions
        ) {

        var search = {
            fetchScoresByMember: function (data) {
                var apipath = ggSettings.gnapi.root + ggSettings.gnapi.scoring.scores + "?";
                var qry = "$filter=memberId eq " + data.memberId;
                var top = "";
                var exp = "";
                var ord = "&$orderby=playDate desc, id desc"


                if (data.top && data.top > 0) {
                    top = "$top=" + data.top + "&";
                } else {
                    top = "$top=1000&"
                }

                return $http.get(apipath + top + qry + exp + ord, {});
            }
        }

        var scoring = {
           fetchScore: function (data) {
              var apipath = ggSettings.gnapi.root + ggSettings.gnapi.scoring.detail;
              apipath = apipath.replace("(id)", "(" + data.scoreId + ")");
              var qry = "";
              var exp = "";
              return $http.get(apipath + qry + exp, {});
           }

           , batchScore: function (data) {
              var apipath = ggSettings.gnapi.root + ggSettings.gnapi.scoring.post;

              var form = {
                 score: data
              }


              // Post the data, but don't transform it.
              return $http.post(apipath, form, false);
           }
        }

        var stats = {
           fetchStatsSummary: function (data) {
              var apipath = ggSettings.gnapi.root + ggSettings.gnapi.scoring.statsummary;
              apipath = apipath.replace("{id}", "" + data.memberId + "");
              apipath = apipath.replace("{filter}", "" + ((data.filter === undefined) ? 'Last20' : data.filter));
              var qry = "";
              var exp = "";
              return $http.get(apipath + qry + exp, {});
           }
        }







        var service = {
            search: search
           , scoring: scoring
           , stats : stats
        }

        return service;
    }
}(angular, app));

